import reduxConnector from 'root/src/shared/util/reduxConnector'

import valueSelector from 'root/src/client/logic/form/selectors/valueSelector'
import arrayFieldMaxItems from 'root/src/client/logic/form/selectors/arrayFieldMaxItems'
import fieldLabel from 'root/src/client/logic/form/selectors/fieldLabel'
import fieldError from 'root/src/client/logic/form/selectors/fieldError'
import fieldHasError from 'root/src/client/logic/form/selectors/fieldHasError'
import fieldPlaceholder from 'root/src/client/logic/form/selectors/fieldPlaceholder'
import uniqueItemsSelector from 'root/src/client/logic/form/selectors/uniqueItemsSelector'
import isMultiSelector from 'root/src/client/logic/form/selectors/isMultiSelector'
import fieldActionButtonSelector from 'root/src/client/logic/form/selectors/fieldActionButtonSelector'
import fieldIconSelector from 'root/src/client/logic/form/selectors/fieldIconSelector'
import inputStrengthSelector from 'root/src/client/logic/form/selectors/inputStrengthSelector'

import setInput from 'root/src/client/logic/form/thunks/setInput'
import fieldActionButton from 'root/src/client/logic/form/thunks/fieldActionButton'

export default reduxConnector(
	[
		['value', valueSelector],
		['arrayFieldMaxItems', arrayFieldMaxItems],
		['fieldError', fieldError],
		['fieldHasError', fieldHasError],
		['fieldLabel', fieldLabel],
		['fieldIcon', fieldIconSelector],
		['fieldPlaceholder', fieldPlaceholder],
		['uniqueItems', uniqueItemsSelector],
		['isMulti', isMultiSelector],
		['inputStrength', inputStrengthSelector],
		['fieldActionButton', fieldActionButtonSelector],
	],
	[
		['setInput', setInput],
		['fieldActionButtonFn', fieldActionButton],
	],
)
